var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popShow)?_c('div',{staticClass:"popup-share-tips",class:[_vm.lang]},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('popup.shareTips'))}}),_c('div',{staticClass:"popup-tips-arrow"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }